import { BootstrapGridBreakpoints } from '@gn-audio/ui/constants/bootstrap-grid-breakpoints';
import { element } from 'angular';
import { Directive, Inject, Input, OnDestroy, OnInit } from 'angular-ts-decorators';

const elevateZoomContainerSelector = '.zoomContainer';
const elevateZoomWindowSelector = `${elevateZoomContainerSelector} .zoomWindow`;
const elevateZoomDataSetKey = 'elevateZoom';

@Directive({
  selector: '[elevateZoom]',
})
export class ElevateZoomDirective implements OnInit, OnDestroy {
  public static $inject: ReadonlyArray<string> = [];

  @Input('@') public elevateZoomThumbnailsSelector?: string;
  @Input('@') public elevateZoomOptionsSelector?: string;

  private $elevateZoomThumbnailsElement?: JQuery;
  private $elevateZoomOptionsElement?: JQuery;

  private lastMouseMoveEvent?: Event;
  private zoomInitialized = false;
  private zoomed = false;

  constructor(@Inject('$element') private $element: JQLite) { }

  public async ngOnInit() {
    await import('@zeitiger/elevatezoom');
    this.$elevateZoomThumbnailsElement = element(this.elevateZoomThumbnailsSelector);
    this.$elevateZoomOptionsElement = element(this.elevateZoomOptionsSelector);

    this.$element.on('click', this.toggle.bind(this));
    this.$element.on('mousemove', this.saveEvent.bind(this));
    this.$elevateZoomThumbnailsElement.on('click', 'img', this.zoomOff.bind(this));
    this.$elevateZoomOptionsElement.on('click', 'label', this.zoomOff.bind(this));
  }

  public ngOnDestroy(): void {
    this.$element?.off('click', this.toggle);
    this.$element?.off('mousemove', this.saveEvent);
    this.$elevateZoomThumbnailsElement?.off('click', this.zoomOff);
    this.$elevateZoomOptionsElement?.off('click', this.zoomOff);
  }

  private initializeZoom(onZoomedImageLoaded?: () => void): void {
    const $imageElement = this.$element.find('img');
    ($imageElement as any).elevateZoom({
      cursor: 'zoom-out',
      onZoomedImageLoaded,
      responsive: true,
      zoomType: 'inner',
    });
    this.zoomInitialized = true;
  }

  private saveEvent(event: Event): void {
    this.lastMouseMoveEvent = event;
  }

  private toggle(): void {
    this.zoomed ? this.zoomOff() : this.zomeOn();
  }

  private zomeOn(): void {
    if (window.innerWidth < BootstrapGridBreakpoints.Medium) {
      if (this.zoomInitialized) {
        this.zoomOff();
      }

      return;
    }

    if (!this.zoomInitialized) {
      this.initializeZoom(this.setPosition.bind(this));
    } else {
      this.setPosition();
    }

    this.zoomed = true;
  }

  private setPosition(): void {
    $(elevateZoomWindowSelector).css('display', 'block').css('top', 0).css('left', 0);
    this.$element.find('img').data(elevateZoomDataSetKey).setPosition(this.lastMouseMoveEvent);
  }

  private zoomOff(): void {
    $(elevateZoomContainerSelector).remove();
    this.zoomInitialized = false;
    this.zoomed = false;
  }
}
